import React, {useState} from "react";
import { Button, Column, Columns, Input, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import ContactSection from "../../Contact/ContactSection";
import DepartmentSelector from "../../Settings/Departments/DepartmentSelector";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";


export default function CreateQuoteModal({show, setShow, rental, endpoint, departments, departmentObjects}){
    const [quoteState, setQuoteState] = useState({
        customer: {},
        customer2: {},
        department: null
    });

    const onCreate = () => {
        let dataToSave = {...quoteState};
        if(rental){
            dataToSave.rental = rental;
            dataToSave.vehicle = rental.vehicle;
            const conf ={
                url: endpoint+"createquotefromrental",
                method: "post",
                data: dataToSave
            }
            axios(conf).then(res => {
                console.log(res.data)
                setShow(false);
                window.open(`/editquote/${res.data.id}`, "_self");
            }).catch(err=>{
                toast.error("There was an error creating quote", {position: "top-right"});
            })
        } else{
            toast.error("Could not find rental. Please refresh page and try again", {position: "top-right"});
        }
    }

    const handleUpdate = data => {
        let newState = {...quoteState, ...data};
        setQuoteState(newState);
    }

    const onChange = e => {
        let data = {[e.target.name]: e.target.value};
        handleUpdate(data);
    }

    const handleUpdateCustomer = (e, name) => {
        let newData = {[name]: e};
        handleUpdate(newData);
    }

    const onDepartmentChange = (e) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: departmentObjects[e.target.value]
            }
        };
        onChange(toUpdate);
    }

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={show}
            onClose={() => setShow(false)}
            closeOnBlur
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Create Quote</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <ContactSection
                                title="Customer 1"
                                contactUpdate={(e) => handleUpdateCustomer(e, "customer")}
                                endpoint={endpoint + "contacts"}
                                contact={quoteState.customer}
                                type="CC"
                                fullSearch
                            />
                        </Column>
                        <Column>
                            <ContactSection
                                title="Customer 2"
                                contactUpdate={(e) => handleUpdateCustomer(e, "customer2")}
                                endpoint={endpoint + "contacts"}
                                contact={quoteState.customer2}
                                type="CC"
                                fullSearch
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <DepartmentSelector
                                options={departments}
                                name={"department"}
                                label={"Department"}
                                onChange={onDepartmentChange}
                                value={quoteState.department}
                                blank={true}
                            />
                        </Column>
                        <Column>
                            <label className="label">Provision Start Date</label>
                            <Input
                                type={"date"}
                                name={"provisional_start_date"}
                                onChange={onChange}
                            />
                        </Column>
                        <Column>
                            <label className="label">Quote Description</label>
                            <Input
                                type={"text"}
                                name={"description"}
                                onChange={onChange}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() => setShow(false)}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={onCreate}
                                isFullWidth
                            >
                                Create
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );







}